import {inject, Injectable} from "@angular/core";
import {NewsApiService} from "../../generated-sources/api/gpt";
import {NewsQuery} from "../../model/news/news-query";
import {Observable} from "rxjs";
import {NewsSearchResult} from "../../model/news/news-search-result";
import {NewsAssessment} from "../../model/news/news-assessment";


@Injectable({
    providedIn: "root"
})
export class NewsService {
    private readonly newsApiService = inject(NewsApiService);

    constructor( ) {
    }

    fetchNews(query: NewsQuery): Observable<NewsSearchResult> {
        return this.newsApiService.fetchNews(query);
    }

    assessNews(searchResult: NewsSearchResult): Observable<NewsAssessment> {
        return this.newsApiService.assessNews(searchResult);
    }
}
